import { ColumnDef } from '@tanstack/react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Text } from 'theme-ui';
import DataTable from '../../../Tabels/Tabel';
import { setPagination } from '../../../../store/actions/Pagination.action';
import { getAllTaskFieldsMasterData } from '../../../../store/actions/masterData.action';
import { TabelHeadingTxt } from '../../../Text/TabelCommonTxt';
import plus from "../../../assets/images/Icon/plus.svg";
import { useNavigate } from 'react-router-dom';
import TableActions from '../../users/TableActions';
const TaskFieldsMapping: React.FC = () => {

    const navigate = useNavigate();
    const [refresh, setRrefresh] = useState<boolean>(true);
    const { taskField, loader } = useSelector((state: any) => state.masterData);
    const { paginations } = useSelector((state: any) => state.pagination);


    const columns = useMemo<ColumnDef<any>[]>(() => [
        // {
        //     accessorKey: "id",
        //     id: "select",
        //     enableColumnFilter: false,
        //     header: ({ table }) => (
        //         <div className="d-flex justify-content-center">
        //             <IndeterminateCheckbox
        //                 {...{
        //                     checked: table.getIsAllRowsSelected(),
        //                     indeterminate: table.getIsSomeRowsSelected(),
        //                     onChange: table.getToggleAllRowsSelectedHandler(),
        //                 }}
        //             />
        //         </div>
        //     ),
        //     cell: ({ row }) => (
        //         <IndeterminateCheckbox
        //             {...{
        //                 checked: row.getIsSelected(),
        //                 disabled: !row.getCanSelect(),
        //                 indeterminate: row.getIsSomeSelected(),
        //                 onChange: row.getToggleSelectedHandler(),
        //             }}
        //         />
        //     ),
        // },
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((paginations?.currentPage - 1) * paginations?.limit) + row?.index + 1}</Text>
                )
            }
        },
        {
            accessorKey: "fieldName",
            header: 'Field Name',
            cell: info => info.getValue(),
        },
        {
            header: 'Task Name',
            accessorKey: "taskName",
            cell: ({ row }) => {
                return (
                    <Text >{row.original.taskName?.name}</Text>
                )
            }
        },
        {
            header: 'Task Type',
            accessorKey: "type",
            cell: info => info.getValue(),
        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-task-field/${row?.original?._id}`} deleteMessage='Are you sure you want to delete this task field sow?' deleteApi={`task-field-sow/delete-task-field-sow/${row?.original?._id}`} toggleRefresh={() => setRrefresh(true)} />
                )
            },
        }
    ], [taskField?.data]);
    useEffect(() => {
        return () => {
            dispatch(setPagination({
                limit: 15,
                currentPage: 1,
            }))
        }
    }, [])
    const dispatch = useDispatch()
    useEffect(() => {
        if (refresh) {
            dispatch(getAllTaskFieldsMasterData(paginations));
            setRrefresh(false);
        }
    }, [refresh])
    const handleclick = () => {
        navigate("/create-task-field")
    }
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Task Field Sow' Count={taskField?.count || 15} BtnTxt='Create Task Field Sow' src={plus} onClick={handleclick} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={taskField?.data || []}
                TotalLength={taskField?.count || 15}
                perPageCount={paginations.limit}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    dispatch(setPagination({
                        limit: itemsPerPage,
                        currentPage: 1
                    }));
                    setRrefresh(true);
                }}
                onPageChange={(value) => {
                    dispatch(setPagination({
                        ...paginations,
                        ...{ currentPage: value }
                    }));
                    setRrefresh(true);
                }} />
        </div>
    )
};

export default TaskFieldsMapping;
